import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UsePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-TH24QTSFSJ', {
        page_path: location.pathname,
      });
    }
  }, [location]);
};

export default UsePageTracking;